import { ISelectedFilters } from '../../components/ProductList/interfaces/ISelectedFilters';

export const filterProducts = (
    products: Array<GQL.IProduct>,
    filters: ISelectedFilters,
    priceFilters: Array<{ value: string }>,
    filterProductsByPrice: (products: Array<GQL.IProduct>, priceFilters: Array<{ value: string }>) => Array<GQL.IProduct>,
    filterVariants: (variants: Array<GQL.IProductVariant>, filters: ISelectedFilters) => Array<GQL.IProductVariant>,
    favorites: Array<GQL.IProductVariant>
): Array<GQL.IProductVariant> => {

    const filtered: { [productId: string]: { [valueId: string]: GQL.IProductVariant } } = {};

    for (const product of filterProductsByPrice(products, priceFilters)) {
        if (filtered[product.id] == undefined) {
            filtered[product.id] = {};
        }

        for (const variant of filterVariants(product.variants || [], filters)) {
            if (!Array.isArray(filtered[product.id]['-1'])) {
                const extendedVariant = variant;
                if ('number' === typeof (product as any).searchPriority) {
                    (extendedVariant as any).searchPriority = (product as any).searchPriority;
                }
                filtered[product.id]['-1'] = extendedVariant;
            }
        }
    }

    const variants = new Array<GQL.IProductVariant>();
    for (const product of Object.keys(filtered)) {
        for (const valueId of Object.keys(filtered[product])) {
            variants.push(filtered[product][valueId]);
        }
    }

    return variants;
};



// WEBPACK FOOTER //
// ./src/helpers/products/filterProducts.ts